import {
  RESET_AUTOMATIC_MESSAGES,
  RESET_AUTOMATIC_MESSAGE,
  RESET_ERROR,
  GET_AUTOMATIC_MESSAGES,
  SET_AUTOMATIC_MESSAGES,
  API_ERROR,
  CREATE_AUTOMATIC_MESSAGE,
  CREATE_AUTOMATIC_MESSAGE_SUCCESS,
  GET_AUTOMATIC_MESSAGE,
  SET_AUTOMATIC_MESSAGE,
  EDIT_AUTOMATIC_MESSAGE,
  EDIT_AUTOMATIC_MESSAGE_SUCCESS,
  DELETE_AUTOMATIC_MESSAGE,
  DELETE_AUTOMATIC_MESSAGE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorAutomaticMessage: false,
  loadingAutomaticMessage: false,
  dataAutomaticMessage: null,
  successAutomaticMessage: false,
};

const AutomaticMessage = (state = initialState, action) => {
  switch (action.type) {
    case RESET_AUTOMATIC_MESSAGES:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: false,
        loadingAutomaticMessageDelete: false,
        successAutomaticMessage: false,
        dataAutomaticMessage: null,
        dataAutomaticMessageDelete: null,
      };
      break;
    case RESET_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: false,
        successAutomaticMessage: false,
        dataAutomaticMessageGetSet: null,
        dataAutomaticMessageEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: false,
        loadingAutomaticMessageEditCreate: false,
        loadingAutomaticMessageActivate: false,
        successAutomaticMessage: false,
      };
      break;
    case GET_AUTOMATIC_MESSAGES:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: true,
        dataAutomaticMessage: null,
      };
      break;
    case SET_AUTOMATIC_MESSAGES:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: false,
        dataAutomaticMessage: action.payload,
      };
      break;
    case CREATE_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageEditCreate: true,
        dataAutomaticMessageEditCreate: action.payload,
        successAutomaticMessage: false,
      };
      break;
    case CREATE_AUTOMATIC_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageEditCreate: false,
        dataAutomaticMessageEditCreate: action.payload,
        successAutomaticMessage: true,
      };
      break;
    case GET_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: true,
        dataAutomaticMessageGetSet: null,
      };
      break;
    case SET_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessage: false,
        dataAutomaticMessageGetSet: action.payload,
      };
      break;
    case EDIT_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageEditCreate: true,
        dataAutomaticMessageEditCreate: action.payload,
        successAutomaticMessage: false,
      };
      break;
    case EDIT_AUTOMATIC_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageEditCreate: false,
        dataAutomaticMessageEditCreate: action.payload,
        successAutomaticMessage: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorAutomaticMessage: action.payload,
        loadingAutomaticMessage: false,
        loadingAutomaticMessageDelete: false,
        successAutomaticMessage: false,
      };
      break;
    case DELETE_AUTOMATIC_MESSAGE:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageDelete: true,
        dataAutomaticMessageDelete: action.payload,
        successAutomaticMessage: false,
      };
      break;
    case DELETE_AUTOMATIC_MESSAGE_SUCCESS:
      state = {
        ...state,
        errorAutomaticMessage: false,
        loadingAutomaticMessageDelete: false,
        dataAutomaticMessageDelete: action.payload,
        successAutomaticMessage: true,
      };
      break;
    default:
      // state = { ...state, errorAutomaticMessage: false, loadingAutomaticMessage: false };
      break;
  }
  return state;
};

export default AutomaticMessage;
